// extracted by mini-css-extract-plugin
export default {"basicDetails":"PatientDetails_basicDetails__Wi8Lk","rowDiv":"PatientDetails_rowDiv__gDtPZ","btnDiv":"PatientDetails_btnDiv__ZUSEH","inputField":"PatientDetails_inputField__Bsi5V"};